import api from "../../api.service";
import store from "../";
import Swal from "sweetalert2";

import Tree from "@/plugins/tree.js";

const state = {
    tree: new Tree(),
    counts: [],
    imagesGallery: [],
    categoriesTree: {
        id: null,
        name: "التصنيفات",
        isParent: false,
        isHidden: false,
        parentCategoryId: null,
        shopCount: 0,
        children: null,
        image: [],
        logo: []
    },
    modelCategory: {
        id: 0,
        name: "",
        isParent: false,
        isHidden: false,
        children: [],
        shopCount: 0,
        parentCategoryId: null,
        image: [],
        logo: []
    }
};

const getters = {
    categoriesTree(state) {
        return state.categoriesTree
    },
    modelCategory(state) {
        return state.modelCategory
    },
    imagesGallery(state){
        return state.imagesGallery
    }
};

const mutations = {
    GET_CATEGIRIES_ITEMS(state, payload) {
        console.log(payload)
        payload.forEach(category => {
            category.shopCount = state.counts.filter(
                cont => cont.id == category.id
            )[0].count;
            state.tree.insertInTree(category, state.categoriesTree);
        });
        store.dispatch("setLoading", false);
    },
    GET_SHOPS_COUNTS(state, payload) {
        state.counts = payload;
        store.dispatch("fetchCategories");
    },
    ACTION_CATEGORY(state, category) {
        console.log(category);
        category.data.image = category.data.image;
        category.data.logo = category.data.logo;
        if (!!category.payload.id) {
            state.tree.updateTree(category.data, state.categoriesTree);
        } else {
            state.tree.insertInTree(category.data, state.categoriesTree);
        }
        Object.assign(state.modelCategory, {
            id: 0,
            name: "",
            isParent: false,
            isHidden: false,
            parentCategoryId: null,
            children: [],
            image: [],
            logo: []
        });
        store.dispatch("setLoading", false);
    },
    DELETE_CATEGORY(state, payload) {
        store.dispatch("setLoading", false);
        state.tree.deleteNode(payload.id, state.categoriesTree);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف التصنيف بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
    },
    FILL_IMGAES_FORM(state, payload) {
        console.log(payload)
        state.imagesGallery = payload
    },
    RESET_TREE(state){
        Object.assign(state.categoriesTree, {
            id: null,
            name: "التصنيفات",
            isParent: false,
            isHidden: false,
            parentCategoryId: null,
            shopCount: 0,
            children: null,
            image: [],
            logo: []
        })
    },
    
    CANT_HIDE(state,payload) {
        console.log(payload);
        store.dispatch("setLoading", false);
        Swal.fire({
            title: "يوجد خطأ !",
            text: `${payload}`,
            icon: "error",
            showConfirmButton: false,
            timer: 3000
        });
    },
};

const actions = {
    async fetchCategories(context, payload) {
        const { data } = await api
            .query(
                `/api/Category/GetCategories${
                    !!payload ? "?parentId=" + payload : ""
                }`
            )
            .then(data => data);
        context.commit("GET_CATEGIRIES_ITEMS", data);
    },
    async getShopsCount(context) {
        await api.get(`/api/Category/GetShopCount`).then(data => {
            context.commit("GET_SHOPS_COUNTS", data.data);
        });
    },
    async ActionCategory(context, payload) {
        store.dispatch("setLoading", true);
        if(payload.image[0] !== null)
        {
            payload.image =payload.image[0];
        }
        else {
            payload.image = {};
        }
        if(payload.logo[0] !== null)
        {
            payload.logo = payload.logo[0];
        }
        else {
            payload.logo = {};
        }
        console.log(payload);
        const { data } = await api
            .post(`/api/Category/SetCategory`, payload)
            .then(data => data);
          
        if (typeof data === 'string') {
            context.commit("CANT_HIDE", data);
        } else {
            context.commit("ACTION_CATEGORY", { data, payload });
        }

    },
    async DeleteCategory(context, payload) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success px-4",
                cancelButton: "btn btn-danger px-4"
            },
            buttonsStyling: true
        });
        swalWithBootstrapButtons
            .fire({
                title: "هل أنت متأكد؟",
                text: "هل فعلاً تريد حذف التصنيف ؟",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "نعم !",
                cancelButtonText: "إلغاء",
                reverseButtons: false
            })
            .then(result => {
                if (result.value) {
                    store.dispatch("setLoading", true);
                    api.delete(
                        `/api/Category/RemoveCategory?categoryId=${payload.id}`
                    ).then(data => {
                        if (data.data) {
                            context.commit("DELETE_CATEGORY", payload);
                        } else {
                            Swal.fire({
                                title: "لايمكن الحذف",
                                text: `لايمكن حذف التصنيف.`,
                                icon: "warning",
                                showConfirmButton: false,
                                timer: 2500
                            });
                            store.dispatch("setLoading", false);
                        }
                    });
                }
            });
    },
    async getGalleryImages(context, type) {
        await api.query(`/api/Category/GetCategoryImages?type=${type}`)
            .then(data => {
                context.commit("FILL_IMGAES_FORM", data.data);
            });
    },
    resetTree(context) {
        context.commit("RESET_TREE");
    }
};

const Categories = {
    state,
    getters,
    actions,
    mutations
};
export default Categories;
